// ─── Design System Color Tokens ────────────────────────────────────────────────
// Linear/shadcn-inspired: zinc scale neutrals + blue-600 brand accent.
// Kept as TS constants for non-Tailwind contexts (inline styles, antd theme, etc.).
// Tailwind utilities (bg-primary, text-muted-foreground) use the CSS vars in index.css.

export const UI_THEME_COLORS = {
  // Backgrounds
  background: '#FAFAFA', // zinc-50
  backgroundCard: '#FFFFFF',
  backgroundMuted: '#F4F4F5', // zinc-100
  backgroundHover: '#F4F4F5', // zinc-100

  // Text
  textPrimary: '#18181B', // zinc-900
  textSecondary: '#71717A', // zinc-500
  textMuted: '#A1A1AA', // zinc-400
  textStrong: '#09090B', // zinc-950

  // Border
  border: '#E4E4E7', // zinc-200
  borderStrong: '#D4D4D8', // zinc-300
  borderNeutral: '#E4E4E7', // zinc-200 (alias for antd compat)

  // Brand accent — blue-600
  primaryAccent: '#2563EB',
  primaryHover: '#1D4ED8', // blue-700
  primarySoft: '#EFF6FF', // blue-50
  primarySelected: '#DBEAFE', // blue-100
  primarySelectedText: '#1E40AF', // blue-800

  // Sidebar (ultra-minimal white)
  sidebarBg: '#FFFFFF',
  sidebarBorder: '#E4E4E7', // zinc-200
  sidebarSelected: '#EFF6FF', // blue-50
  sidebarSelectedBorder: '#2563EB',
  sidebarHover: '#F4F4F5', // zinc-100

  // Auth
  authBackgroundGradient: 'linear-gradient(160deg, #09090B 0%, #18181B 50%, #1C1917 100%)',
  authBrandGradient: 'linear-gradient(145deg, #1E40AF 0%, #2563EB 100%)',

  // Map
  mapPreviewGradient: 'linear-gradient(135deg, #EFF6FF 0%, #BFDBFE 100%)',
  poiMapGradient:
    'radial-gradient(circle at 20% 20%, #DBEAFE, #93C5FD 35%, #60A5FA 60%, #3B82F6 100%)',
  poiMapRadiusBorder: 'rgba(37, 99, 235, 0.8)',
  poiMapRadiusFill: 'rgba(37, 99, 235, 0.14)',

  // Misc
  white: '#FFFFFF',
  neutral50: '#FAFAFA', // zinc-50
  neutral100: '#F4F4F5', // zinc-100
  neutral200: '#E4E4E7', // zinc-200
  tableHeader: '#FAFAFA', // zinc-50
  tableRowHover: '#F4F4F5', // zinc-100

  // Compatibility aliases — kept so existing consumers don't break during migration
  whiteAlpha15: 'rgba(255,255,255,0.15)',
  whiteAlpha40: 'rgba(255,255,255,0.4)',
} as const

// Tenant theme defaults — updated to use new brand palette
export const TENANT_THEME_DEFAULT_COLORS = {
  primary: '#2563EB', // blue-600
  secondary: '#16A34A', // green-600
  accent: '#EA580C', // orange-600
} as const

// Status/semantic colors
export const UI_STATUS_COLORS = {
  info: '#2563EB', // blue-600
  cyan: '#0891B2', // cyan-600
  success: '#16A34A', // green-600
  warning: '#CA8A04', // yellow-600
  warningStrong: '#EA580C', // orange-600
  muted: '#A1A1AA', // zinc-400
  subtle: '#D4D4D8', // zinc-300
  disabled: '#E4E4E7', // zinc-200
  neutralIcon: '#71717A', // zinc-500
  danger: '#DC2626', // red-600
} as const
